import {
  getTypeOfUser,
  ServiceTypes,
  TypeOfUser,
  UmbrellaUserTypes,
} from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';

import { useAppSelector } from '../useAppSelector';
import strings from '../../localization';

const { pharmacist, student, technician } = TypeOfUser;

const { self, full } = ServiceTypes;

const professionals = new Set([pharmacist, student, technician]);

const useProfessional = () => {
  const userType = useAppSelector(getTypeOfUser);
  const serviceType = ServiceHandler.getService();

  const isSelfService = serviceType === self;
  const isProfessional = professionals.has(userType);

  let selfUserType: any = userType;

  if (isProfessional) {
    if (isSelfService) {
      selfUserType = UmbrellaUserTypes.professional;
    } else {
      selfUserType = TypeOfUser.pharmacist;
    }
  }

  const config = {
    [full]: {
      clientLabel: strings.pharmacist,
    },
    [self]: {
      clientLabel: strings.professional,
    },
  };

  return { isProfessional, selfUserType, ...config[serviceType] };
};

export default useProfessional;
